var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ActivatedRoute } from '@angular/router';
import { ApiService } from './../services/api.service';
import { OnInit, OnDestroy } from '@angular/core';
import { UserService } from '../services/user.service';
var NotificationsComponent = /** @class */ (function () {
    function NotificationsComponent(userService, apiService, route) {
        var _this = this;
        this.userService = userService;
        this.apiService = apiService;
        this.unreadNotificationsList = [];
        this.readNotificationsList = [];
        this.subscriptions = [];
        this.newNotificationsCount = 0;
        this.subscriptions.push(route.data.subscribe(function (_a) {
            var data = _a.data;
            _this.mapDataToState(data.user);
        }));
    }
    NotificationsComponent.prototype.ngOnInit = function () {
        var _this = this;
        // Listen for new messages
        this.subscriptions.push(this.userService.user.subscribe(function (user) {
            // Check how many new unreads there are
            _this.newNotificationsCount = user.unread_notifications.filter(function (noti) {
                return !_this.unreadNotifications.some(function (notiOld) { return notiOld.id === noti.id; });
            }).length;
        }));
    };
    NotificationsComponent.prototype.ngOnDestroy = function () {
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
    };
    NotificationsComponent.prototype.markAsRead = function () {
        return __awaiter(this, void 0, void 0, function () {
            var lastUnread;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        lastUnread = this.unreadNotifications[0];
                        if (!lastUnread) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.apiService
                                .post('mark-notifications-read', {
                                date: lastUnread.created_at,
                            })
                                .toPromise()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.userService.refreshUser()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    NotificationsComponent.prototype.mapDataToState = function (user) {
        this.user = user;
        this.unreadNotifications = user.unread_notifications;
        this.unreadNotificationsList = user.unread_notifications
            .map(this.mapNotification.bind(this))
            .filter(function (x) { return !!x; });
        this.readNotificationsList = user.read_notifications
            .map(this.mapNotification.bind(this))
            .filter(function (x) { return !!x; });
        this.newNotificationsCount = 0;
        this.markAsRead();
    };
    NotificationsComponent.prototype.mapNotification = function (notification) {
        switch (notification.data.type) {
            case 'bounty_comment':
                return this.bountyCommentData(notification);
            case 'claim_comment':
                return this.claimCommentData(notification);
            case 'claim_made':
                return this.claimMadeData(notification);
            case 'claim_accepted':
            case 'claim_denied':
            case 'claim_withdrawn':
                return this.claimResultData(notification);
            case 'bounty_completed':
                return this.bountyCompletedData((notification));
            case 'refund':
                return this.refundData(notification);
        }
    };
    NotificationsComponent.prototype.refundData = function (notification) {
        return __assign({}, this.baseNotificationData(notification), { header: 'Your bounty pool contribution has been refunded', link: "/user/" + this.user.id });
    };
    NotificationsComponent.prototype.baseNotificationData = function (notification) {
        return {
            timeAgo: notification.timeAgo,
            icon: 'bell',
        };
    };
    NotificationsComponent.prototype.bountyCompletedData = function (notification) {
        var success = !!notification.data.username;
        var event = success
            ? 'been marked as paid. You have earned a star!'
            : 'ended with no winner. Do you want to renew it?';
        return __assign({}, this.baseNotificationData(notification), { header: "Your bounty has " + event, link: "/bounties/" + notification.data.bounty_id, icon: success ? 'money' : 'hourglass outline' });
    };
    NotificationsComponent.prototype.claimResultData = function (notification) {
        var action = notification.data.type.substr('claim_'.length);
        var success = notification.data.type === 'claim_accepted';
        var subject = notification.data.type === 'claim_withdrawn' ? 'their' : 'your';
        var targetSubject = notification.data.type === 'claim_withdrawn' ? 'your' : 'their';
        var after = success ? '. You should be paid within 7 days.' : '';
        return __assign({}, this.baseNotificationData(notification), { header: notification.data.username + " has " + action + " " + subject + " claim for " + targetSubject + " bounty reward" + after, link: "/claims/" + notification.data.claim_id, icon: success ? 'trophy' : 'times circle' });
    };
    NotificationsComponent.prototype.claimMadeData = function (notification) {
        return __assign({}, this.baseNotificationData(notification), { header: notification.data.username + " has made a claim for your bounty reward!", link: "/claims/" + notification.data.claim_id, icon: 'circle outline' });
    };
    NotificationsComponent.prototype.bountyCommentData = function (notification) {
        return __assign({}, this.baseNotificationData(notification), { header: notification.data.username + " commented on your bounty" + (notification.data.type === 'bounty_comment' ? '' : ' claim'), link: "/bounties/" + notification.data.bounty_id, icon: 'conversation' });
    };
    NotificationsComponent.prototype.claimCommentData = function (notification) {
        return __assign({}, this.baseNotificationData(notification), { header: notification.data.username + " commented on a bounty claim", link: "/claims/" + notification.data.claim_id, icon: 'conversation' });
    };
    return NotificationsComponent;
}());
export { NotificationsComponent };
